import React from 'react';
import ConfirmPassword from './common/auth/ConfirmPassword';
import CustomAuthentication from './common/auth/CustomAuthentication';
import Logout from './common/auth/Logout';
import PreLogin from './common/auth/PreLogin';
import Signup from './common/auth/Signup';
import Verify from './common/auth/Verify';
import VerifyUser from './common/auth/VerifyUser';
import { RouteType } from './common/nav/AppRoute';
import InvitationResponse from './common/workflow/InvitationResponse';
import InquiryResponse from './shortlists/InquiryResponse';

export const authRoutes: RouteType[] = [
    {
        path: `/login`,
        component: <PreLogin />
    },
    {
        path: `/assessavails`,
        component: <InquiryResponse />
    },
    {
        path: `/logout`,
        component: <Logout />
    },
    {
        path: `/signup`,
        component: <Signup />
    },
    {
        path: `/verify`,
        component: <Verify />
    },
    {
        path: `/invitations/:invitationId`,
        component: <InvitationResponse />
    },
    {
        path: `/password/recovery`,
        component: <VerifyUser />
    },
    {
        path: `/password/recovery/authentication`,
        component: <CustomAuthentication />
    },
    {
        path: `/password/recovery/confirm`,
        component: <ConfirmPassword />
    }
];
